module.exports = __webpack_public_path__ + "img/01n.8821a157.png";